<div class="form-group" [ngClass]="{'multiselect-fixed-width': !disableDelete}">
  <div class="d-inline">
    <label class="d-flex justify-content-between">
      {{criteriaTemplate.field!.title + ' ' + criteriaTemplate.operation!.operation}}
      <i class="icomoon icomoon-exit align-self-center" *ngIf="!disableDelete" (click)="onDelete.emit(expression)"></i>
    </label>
  </div>
  <angular2-multiselect
    (onSelect)="onItemSelect($event)"
    (onDeSelect)="onItemDeselect($event)"
    (onSelectAll)="onSelectAll()"
    (onDeSelectAll)="onDeselectAll()"
    (onRemoteSearch)="load($event.target.value)"
    [(ngModel)]="selectedValue"
    [data]="data"
    [settings]="dropdownSettings"
  #multiSelect>
  </angular2-multiselect>
</div>
